export default {
    async addToken () {
        const tokenAddress = process.env.EGG || "0x526E61397e610f18f2EeB2ab3A283de707f72Df6"
        const tokenSymbol = 'EGGS';
        const tokenDecimals = 18;
        const tokenImage = 'https://eggs.game/myTokenIcon';

        try {
            // wasAdded is a boolean. Like any RPC method, an error may be thrown.
            const wasAdded = await ethereum.request({
                method: 'wallet_watchAsset',
                params: {
                    type: 'ERC20', // Initially only supports ERC20, but eventually more!
                    options: {
                        address: tokenAddress, // The address that the token is at.
                        symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
                        decimals: tokenDecimals, // The number of decimals in the token
                        image: tokenImage, // A string url of the token logo
                    },
                },
            });

            if (wasAdded) {
                console.log('Thanks for your interest!');
            } else {
                console.log('Your loss!');
            }
            } catch (error) {
            console.log(error);
            }
    }
}